import React, { useEffect, useState } from 'react'
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import "./style.scss"
import { getWebinarDetail, saveWebinarData } from 'service/miscellaneous';
import { history } from 'helpers';
import { Toast } from 'service/helpers/toast';
import AcUnitIcon from '@material-ui/icons/AcUnit';
import layout from "assets/icons/layout.png"
import egImage from "assets/images/egImage.png"
import meradocDoc from "assets/images/webinar/doctorMeradoc.png"
import doctorOutside from "assets/images/webinar/doctorOutside.png"
import moment from 'moment';
import { Dialog, DialogTitle } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';


export default function WebinarPage() {
    let [stateData, setstateData] = useState({
        phone: "", fullName: "", corporateName: "", email: ""
    })

    let [webinarDetail, setwebinarDetail] = useState({})
    const [openDialog, setopenDialog] = useState(false)


    let [TandC, setTandC] = useState(false)

    const werbDetails = async () => {

        let dataDetails = await getWebinarDetail()
        console.log(dataDetails, "dataDetails")
        if (dataDetails.status === 200) {
            setwebinarDetail(dataDetails.data.data)
        }
    }
    useEffect(() => {
        werbDetails()
    }, [])
    console.log(webinarDetail, "webinarDetail")
    const saveWebinarFunc = async (e) => {
        e.preventDefault("")
        if (TandC) {
            setopenDialog(true)
            debugger
            let doctors=[]
            doctors.push(webinarDetail.meradocDoc1)
            doctors.push(webinarDetail.meradocDoc2)

            let payload = {
                ...stateData, webinarName: webinarDetail?.webinarName
                , doctors: doctors
            }
            let data = await saveWebinarData(payload)
            if (data.status === 200 && data.data.status == 200) {


                setTimeout(() => {
                    window.open("https://meradoc-webinar-1721.app.100ms.live/meeting/rrk-qkoy-zyn", "_self")
                }, 2000);
                
                // console.log(data, "saved data")
            }

        }
        else {
            Toast({
                message: "Please Accept T&C",
                type: "error"
            })
        }
    }
    const closeDialog = () => { setopenDialog(false) }
    const DialogBox = () => {
        return <Dialog open={openDialog} onClose={closeDialog} aria-labelledby="simple-dialog-title">
            <DialogTitle id="simple-dialog-title"></DialogTitle>
            <div className=" checkIcon text-center"><CheckCircleIcon style={{ color: "#99C8F3", margin: "auto", fontSize: "5rem" }} onClick={() => {
                setopenDialog(false)
                // history.push("/mdiagnostic/diagnosticIndivdual")


            }} /></div>

            <div className="p-3" style={{ fontSize: "1.4rem", fontFamily: "poppins", textAlign: "center", opacity: 10 }}>
                Your Response Has Been Saved
            </div>
            {/* <button onClick={()=>setopenDialog(false)}>Close</button> */}
        </Dialog>
    }

    return (
        <div className='d-flex webinarMainCss py-5' >
            <div className="row ">
                <div className="firstPart col-md-6">
                    <p className='betterCare'>{webinarDetail?.title && webinarDetail?.title}</p>
                    <p className='journeyWellness mt-0 '>Journey to Wellness: Register Now for a Transformative Experience at the Meradoc Health Insights Webinar!</p>
                    <div className='timeDiv my-5 px-md-3 px-sm-auto'>
                        <div className=' borderVisib '></div>
                        <div className='datePart2  '>
                            <div className=''><CalendarTodayIcon /><span className='dateText pl-1'> {webinarDetail?.date && moment(webinarDetail.date).format("MMMM DD")}</span>  </div>
                            <div className='middle_border' > </div>
                            <div className='  d-flex align-items-center ' ><QueryBuilderIcon /><span className='dateText pl-2'> {webinarDetail?.timeStart}</span></div>
                        </div>
                    </div>

                    <div className='webSpeaker'>
                        <span><p>WEBINAR </p></span> <span> </span> <span className='Speaker ml-2'> SPEAKER</span>
                    </div>

                    <div className='d-flex speakerDiv '>
                        {webinarDetail?.visibleMeradocDoc1 && <span>
                            <div className='d-flex  align-items-center'>
                                <span className=''>
                                    <img className='docIMG' src={webinarDetail?.meradocDoc1.image} />
                                </span>
                                <span className='ml-3'>
                                    <p className='nameOfauth p-0 m-0'>{webinarDetail?.meradocDoc1?.name}</p>
                                    <p className='authDesg p-0 m-0'>{webinarDetail?.meradocDoc1?.education}</p>
                                    <p className='authDesg p-0 m-0'>Experience : {webinarDetail?.meradocDoc1?.experience}</p>
                                    <p className='authDesg p-0 m-0'> {webinarDetail?.meradocDoc1.description}</p>
                                </span>
                            </div>

                        </span>}

                        { webinarDetail?.visibleMeradocDoc2 && <span className='ml-3'>
                            <div className='d-flex align-items-center'>
                                <span className=''>
                                    <img className='docIMG' src={webinarDetail?.meradocDoc2.image} />
                                </span>
                                <span className='ml-3'>
                                    <p className='nameOfauth p-0 m-0'>{webinarDetail?.meradocDoc2?.name}</p>
                                    <p className='authDesg p-0 m-0'>{webinarDetail?.meradocDoc2?.education}</p>
                                    <p className='authDesg p-0 m-0'>Experience : {webinarDetail?.meradocDoc2?.experience}</p>
                                    <p className='authDesg p-0 m-0'> {webinarDetail?.meradocDoc2.description}</p>

                                </span>
                            </div>
                        </span>}
                    </div>

                    {/* <div className='d-flex my-4 d-md-block d-sm-flex justify-content-center'>
                        <img src={layout} /><span className='meradocWeb ml-2'>www.meradoc.com</span>
                    </div> */}
                </div>

                <div className=' w-100   col-md-6 mt-md-2 mt-sm-4'>
                    <form className='formPart' onSubmit={saveWebinarFunc} >
                        <p className='registerPara text-center  mb-0'>Register For Webinar</p>
                        <p className=' text-center mt-0'>We love to welcome you, please fill this form</p>
                        <div className='my-3'>
                            <label className='formLabel'>Full Name</label>
                            <div>
                                <input type='text' required className='textType' onChange={(e) => setstateData({ ...stateData, fullName: e.target.value })} placeholder='Enter Here' />
                            </div>
                        </div>
                        <div className='my-3'>
                            <label className='formLabel'>Email</label>
                            <div>
                                <input type='email' required className='textType' title='please fill coorect email' onChange={(e) => setstateData({ ...stateData, email: e.target.value })} placeholder='Enter Here' />
                            </div>
                        </div>
                        <div className='my-3'>
                            <label className='formLabel'>Phone number</label>
                            <div>
                                <input type='text' required className='textType' pattern="[6789]\d{9}" onChange={(e) => setstateData({ ...stateData, phone: e.target.value })} placeholder='Enter Here' />
                            </div>
                        </div>
                        <div className='my-3'>
                            <label className='formLabel'>Corporate Name</label>
                            <div>
                                <input type='text' required className='textType' onChange={(e) => setstateData({ ...stateData, corporateName: e.target.value })} placeholder='Enter Here' />
                            </div>
                        </div>
                        <div className='mt-5 mb-2 d-flex align-items-center'>
                            <input type='checkbox' onChange={(e) => setTandC(e.target.checked)} className='checkBox' />

                            <span className=' ml-2'>You agree to our friendly <u className='pb-2' onClick={() => window.open("auth/terms?TYPE=TERMS_AND_CONDITIONS")}> privacy policy</u></span>

                        </div>
                        <div className='my-3'>
                            <button type='submit' className='btn-submit'  >Submit</button>
                        </div>
                    </form>
                </div>
            </div>
            {openDialog && <DialogBox />}
        </div>

    )
}
